module.exports = __webpack_public_path__ + "static/cabina-conductor---tablero-de-control-1330d339a418e2efbe00e08dfdc29d2c.jpg";